import React, { useEffect, useMemo } from "react";

import "./LinkedinData.css";
import { useLoadTypeContentData } from "../../../../Utils/customHooks/UpToDateContent/useLoadTypeContent";
import { getContentFeedDateWindowFromComponent } from "../../../../Screens/DashboardView/StayUpToDate/AddComponentPicker/contentFeedTimeframe";
import { StayFeedLoadingPlaceholder } from "../../../../Screens/DashboardView/MasterTemplateEditor/WebsiteLibFeedSkeleton";
import { useParams } from "react-router-dom";
import {
  handleFirstImage,
  updateIsEmptyStatus,
} from "../../../../Utils/StayUpToDate/RenderComponent";

import { useDomLoaded } from "../../../../hooks/DomLoadedContext";
import PostTemplate from "../CommonComponents/PostTemplate";
import { FeedSectionEmptyState } from "../FeedSectionEmptyState";
import { websiteEditorFeedEmptyMessage } from "../../../../Screens/DashboardView/MasterTemplateEditor/websiteEditorFeedEmptyMessage";

const LinkedinData = (props: any) => {
  let platform = props.platform || "linkedin";
  let type = props.type || "TWEET";
  const itemsPerPage = 3;

  const param = useParams();

  const {
    user_id,
    username,
    title,
    handleRedirect,
    brand_color,
    isHandleNavigate,
    component,
    removedPostIds,
    isLinks,
    from,
    designTokens,
    templateGridLoaderProps,
    showEmptyInEditor = false,
  } = props;
  const contentDateWindow = useMemo(
    () => getContentFeedDateWindowFromComponent(component),
    [component?.details, component?.id]
  );

  const { isLoading: LinkedinDataLoading, data: LinkedinData }: any =
    useLoadTypeContentData(
      username,
      user_id,
      platform,
      type,
      removedPostIds,
      component?.content_order,
      component?.custom_order?.split(","),
      component?.shoppable_content_filter,
      component?.pinned_posts?.split(",") || [],
      component?.shoppable_status_filter || "all",
    "default",
    "default",
    true,
    contentDateWindow
  );

  const linkedinItems = useMemo(() => {
    if (!LinkedinData?.pages?.length) {
      return [];
    }
    return LinkedinData.pages.reduce((acc: any[], page: any) => {
      if (Array.isArray(page?.data)) {
        acc.push(...page.data);
      }
      return acc;
    }, []);
  }, [LinkedinData]);
  const totalCount = LinkedinData?.pages?.[0]?.total_count ?? 0;
  const domLoaded = useDomLoaded();
  useEffect(() => {
    const checkEmptyStatus = async () => {
      if (!LinkedinDataLoading) {
        if (!LinkedinData || totalCount === 0) {
          if (!showEmptyInEditor) {
            await updateIsEmptyStatus(title, user_id, component.id,from);
          }
          // setIsLoading(false);
        } else {
          await handleFirstImage(
            title,
            component?.id,
            linkedinItems?.[0],
            user_id,
            from
          );
          // setIsLoading(false);
        }
      }
    };
    checkEmptyStatus();
  }, [LinkedinDataLoading, LinkedinData, linkedinItems, totalCount]);

  return (
    <>
      {LinkedinDataLoading || !domLoaded ? (<StayFeedLoadingPlaceholder
          designTokens={designTokens}
          from={from}
          component={component}
          templateGridLoaderProps={templateGridLoaderProps}
        />) : (
        <>
          {linkedinItems && linkedinItems.length ? (
            <PostTemplate
              processedData={linkedinItems}
              total_count={totalCount}
              component={component}
              user_id={user_id}
              username={username}
              handleRedirect={handleRedirect}
              brand_color={brand_color}
              title={title}
              from={from}
              type={type}
              itemsPerPage={itemsPerPage}
              platform={platform}
              pinnedPostIds={component?.pinned_posts?.split(",") || []}
              isLinks={isLinks}
              designTokens={designTokens}
            />
          ) : showEmptyInEditor ? (
            <FeedSectionEmptyState
              title={title}
              designTokens={designTokens}
              message={websiteEditorFeedEmptyMessage("platform", { platform: "LinkedIn" })}
            />
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default LinkedinData;
